import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HistorySection from 'Components/HistorySection';
import type { IHistoryContext } from 'Containers/FormContextHandler';
import { withHistoryContext } from 'Containers/FormContextHandler';
import type { RelevantDocumentType } from '../definitions';
import { TreatmentHistorySection } from './components';
import { DocumentCreationButtonWithContext } from './components/DocumentCreationButtonWithContext';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<RelevantDocumentType>[] = [];
const MADTherapy = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  view,
}: IHistoryContext<IDocumentWithTypeV2<RelevantDocumentType>>): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="treatment.madTherapy.title" />}
    newButton={<DocumentCreationButtonWithContext name="madTherapy" text="treatment.madTherapy.newMadTherapy" />}
  >
    <TreatmentHistorySection documents={documents} startEdit={startEdit} type="madTherapy" view={view} />
  </HistorySection>
);

export default withHistoryContext(MADTherapy);
